export default "__VITE_ASSET__2379b773__"